import { render, staticRenderFns } from "./ValidacionInformacionAdd.vue?vue&type=template&id=540ded33&"
import script from "./ValidacionInformacionAdd.vue?vue&type=script&lang=js&"
export * from "./ValidacionInformacionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports